export enum IntegrationAppName {
  CONCRETE_DIRECT = 'concreteDirect',
  MATURIX = 'maturix',
  PROCORE = 'procore',
}
